(function () {
    'use strict';
    angular
        .module('ActionManager')
        .factory('action-show-confirmation', actionFunc);

    function actionFunc(ModalService, ButtonRegistry, lodash) {
        return function (options, eventData, actionResponse) {
            return ModalService.showModal({
                template: options.dialogTemplate,
                controller: 'ConfirmationDialogCtrl',
                controllerAs: 'vm',
                appendElement: angular.element('.modal-wrapper'),
                inputs: {
                    dialogOptions: angular.extend(options.dialogOptions || {}, {response_data: actionResponse})
                }
            }).then(function (modal) {
                modal.element.show();
                return modal.close.then(function (result) {
                    if (!lodash.has(options, 'dontClearLoading') || result === false) {
                        ButtonRegistry.clearAllLoading();
                    }
                    if (!result) {
                        return result;
                    }
                    if (lodash.has(options, 'useEventData') && options.useEventData) {
                        return eventData;
                    }
                    if (lodash.has(options, 'useActionResponse') && options.useActionResponse) {
                        return actionResponse;
                    }
                    return result;
                });
                // return modal.close;
            });
        };
    }
})();
